import React from "react";
import "./StatCards.css";

const StatCards = ({ animVisitor, animMain, animCat, animSub }) => {
  return (
    <div className="container mt-4 mb-4">
      <div className="row text-center g-3">

        {/* Total Visitors */}
        <div className="col-6 col-sm-6 col-md-3 stat-col">
          <div className="card stat-card stat-info shadow-lg">
            <div className="card-body">
              <i className="bi bi-people-fill"></i>
              <h5>Total Visitors</h5>
              <h2 className={animVisitor.finished ? "count-bounce" : ""}>
                {animVisitor.count}+
              </h2>
            </div>
          </div>
        </div>

        {/* Main Categories */}
        <div className="col-6 col-sm-6 col-md-3 stat-col">
          <div className="card stat-card stat-primary shadow-lg">
            <div className="card-body">
              <i className="bi bi-layers"></i>
              <h5>Service Group</h5>
              <h2 className={animMain.finished ? "count-bounce" : ""}>
                {animMain.count}+
              </h2>
            </div>
          </div>
        </div>

        {/* Categories */}
        <div className="col-6 col-sm-6 col-md-3 stat-col">
          <div className="card stat-card stat-success shadow-lg">
            <div className="card-body">
              <i className="bi bi-grid-fill"></i>
              <h5>Service Type</h5>
              <h2 className={animCat.finished ? "count-bounce" : ""}>
                {animCat.count}+
              </h2>
            </div>
          </div>
        </div>

        {/* Subcategories */}
        <div className="col-6 col-sm-6 col-md-3 stat-col">
          <div className="card stat-card stat-warning shadow-lg">
            <div className="card-body">
              <i className="bi bi-diagram-3-fill"></i>
              <h5> Service Action</h5>
              <h2 className={animSub.finished ? "count-bounce" : ""}>
                {animSub.count}+
              </h2>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default StatCards;
